import { lazy } from 'react';

/**
 * React.lazy pour une page, avec un rechargement unique si le fichier n'existe plus :
 * après un déploiement, un onglet resté ouvert peut demander un ancien morceau (chunk)
 * qui a été remplacé. On recharge alors la page une fois pour récupérer la nouvelle version.
 */
const RELOAD_KEY = 'secura.chunkReloadAt';

export default function lazyPage(importer) {
  return lazy(() =>
    importer().catch((err) => {
      let last = 0;
      try {
        last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
      } catch {
        // stockage indisponible : pas de rechargement automatique
      }
      if (Date.now() - last > 30000) {
        try {
          sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
        } catch {
          // idem
        }
        window.location.reload();
        return new Promise(() => {}); // la page se recharge
      }
      throw err;
    })
  );
}
